export default __webpack_public_path__ + "static/media/958.32387d22.png";